import {SET_SNILS} from "./types";

export const setSnils = (snils) => {
    return {
        type: SET_SNILS,
        payload: snils
    }
}